// import React, { useEffect, useState } from "react";
// import Cookies from "js-cookie";
// import {
//   Layout,
//   Menu,
//   Button,
//   message,
//   Spin,
//   Flex,
//   Tooltip,
//   Drawer,
// } from "antd";
// import { Navigate, Outlet, useNavigate } from "react-router-dom";
// import { logOut } from "../Service/logout";
// import { useSessionRefresh } from "./useSessionRefresh";
// import Sider from "antd/es/layout/Sider";
// import { MdLogout, MdMenu } from "react-icons/md";
// import { BiSolidUserCircle } from "react-icons/bi";
// import { usePermissions } from "../../context/PermissionContext";

// // ── Single source of truth for the menu ──────────────────────────────────────
// // To remove a module for a client, edit menuConfig.js — it updates both
// // the sidebar here and the dashboard cards automatically.
// import { buildMenuItems } from "../../utils/menuConfig";

// const { Content, Header } = Layout;

// const DESKTOP_BREAKPOINT = 1024;

// // ─── SidebarContent ───────────────────────────────────────────────────────────
// const SidebarContent = ({ showTitle = true, onNavigate, menuItems, userDetails, onToggle, onLogout }) => (
//   <>
//     <Button
//       type="text"
//       block
//       onClick={onToggle}
//       style={{ margin: "15px 0px" }}
//     >
//       <img
//         src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
//         alt="Logo"
//         style={{ width: "3rem", height: "auto", borderRadius: "50%" }}
//       />
//       {showTitle && <h3 style={{ margin: 0 }}>Step to Innovation</h3>}
//     </Button>

//     <Menu
//       mode="inline"
//       onClick={({ key }) => { if (onNavigate) onNavigate(key); }}
//       style={{
//         overflowY: "auto",
//         height: "calc(100vh - 170px)",
//         scrollbarWidth: "none",
//       }}
//       items={menuItems}
//     />

//     <div
//       style={{
//         position: "absolute",
//         bottom: 0,
//         width: "100%",
//         background: "white",
//         padding: "10px",
//         borderTop: "1px solid #f0f0f0",
//         textAlign: "center",
//       }}
//     >
//       <Flex
//         align="center"
//         justify={showTitle ? "flex-start" : "center"}
//         style={{ marginBottom: "8px" }}
//       >
//         {showTitle ? (
//           <>
//             <BiSolidUserCircle style={{ fontSize: "40px", marginRight: "10px", color: "gray" }} />
//             <div style={{ textAlign: "start" }}>
//               <div>{userDetails?.name || "User Name"}</div>
//               <small style={{ color: "gray" }}>
//                 {userDetails?.roles || userDetails?.role || "User Role"}
//               </small>
//             </div>
//           </>
//         ) : (
//           <Tooltip
//             title={
//               <div style={{ textAlign: "start" }}>
//                 <div>{userDetails?.name || "User Name"}</div>
//                 <small>{userDetails?.roles || userDetails?.role || "User Role"}</small>
//               </div>
//             }
//             placement="right"
//           >
//             <BiSolidUserCircle style={{ fontSize: "40px", color: "gray" }} />
//           </Tooltip>
//         )}
//       </Flex>
//       <Button
//         type="text"
//         block
//         onClick={onLogout}
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           gap: showTitle ? "8px" : "0px",
//         }}
//       >
//         <MdLogout /> {showTitle && "Logout"}
//       </Button>
//     </div>
//   </>
// );

// // ─── HomePage ─────────────────────────────────────────────────────────────────
// const HomePage = () => {
//   const [open, setOpen] = useState(true);
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= DESKTOP_BREAKPOINT);
//   const navigate = useNavigate();
//   const [messageApi, contextHolder] = message.useMessage();
//   const [isLoading, setIsLoading] = useState(false);
//   const [userDetails, setUserDetails] = useState(null);
//   const { can, loading: permLoading } = usePermissions();

//   useEffect(() => {
//     const handler = () => setIsMobile(window.innerWidth <= DESKTOP_BREAKPOINT);
//     window.addEventListener("resize", handler);
//     return () => window.removeEventListener("resize", handler);
//   }, []);

//   const toggleDrawer = () => setOpen((v) => !v);

//   const logout = () => {
//     setIsLoading(true);
//     logOut()
//       .catch((err) => {
//         messageApi.open({
//           type: "error",
//           content: err.message || err.response?.data?.message,
//         });
//       })
//       .finally(() => {
//         Cookies.remove("user_details");
//         Cookies.remove("AUTH_TOKEN");
//         Cookies.remove("REFRESH_TOKEN");
//         navigate("/login", { replace: true });
//         setIsLoading(false);
//       });
//   };

//   useEffect(() => {
//     const details = Cookies.get("user_details");
//     if (details) {
//       try {
//         setUserDetails(JSON.parse(details));
//       } catch {
//         setUserDetails(null);
//       }
//     }
//   }, []);

//   useSessionRefresh();

//   // buildMenuItems is now imported from menuConfig.js
//   // Pass can + userDetails as params — no more closure dependency
//   const menuItems = buildMenuItems({ can, userDetails });

//   const isLoggedIn = Cookies.get("user_details");
//   return isLoggedIn ? (
//     <Spin spinning={isLoading || permLoading}>
//       {contextHolder}
//       <Layout style={{ height: "100vh" }}>
//         <Layout>

//           {/* ── TABLET & MOBILE ── */}
//           {isMobile && (
//             <>
//               <Header
//                 style={{
//                   position: "sticky",
//                   top: 0,
//                   zIndex: 100,
//                   width: "100%",
//                   background: "white",
//                   padding: "0 16px",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "12px",
//                   borderBottom: "1px solid #f0f0f0",
//                   height: "56px",
//                   boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
//                 }}
//               >
//                 <Button
//                   type="text"
//                   icon={<MdMenu style={{ fontSize: "22px" }} />}
//                   onClick={() => setDrawerOpen(true)}
//                 />
//                 <img
//                   src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
//                   alt="Logo"
//                   style={{ width: "2rem", height: "auto", borderRadius: "50%" }}
//                 />
//                 <h3 style={{ margin: 0, fontSize: "16px" }}>Step to Innovation</h3>
//               </Header>

//               <Drawer
//                 placement="left"
//                 open={drawerOpen}
//                 onClose={() => setDrawerOpen(false)}
//                 width={260}
//                 styles={{ body: { padding: 0, position: "relative" } }}
//                 title={null}
//                 closable={false}
//               >
//                 <SidebarContent
//                   onNavigate={(key) => { navigate(key); setDrawerOpen(false); }}
//                   menuItems={menuItems}
//                   userDetails={userDetails}
//                   onLogout={logout}
//                 />
//               </Drawer>
//             </>
//           )}

//           {/* ── DESKTOP ── */}
//           {!isMobile && (
//             <Sider
//               style={{
//                 background: "white",
//                 overflow: "hidden",
//                 height: "100vh",
//                 position: "sticky",
//                 insetInlineStart: 0,
//                 top: 0,
//                 bottom: 0,
//                 scrollbarWidth: "none",
//                 scrollbarGutter: "stable",
//               }}
//               collapsible
//               collapsed={!open}
//               onCollapse={toggleDrawer}
//               width={250}
//               trigger={null}
//             >
//               <SidebarContent
//                 showTitle={open}
//                 onNavigate={(key) => navigate(key)}
//                 onToggle={toggleDrawer}
//                 menuItems={menuItems}
//                 userDetails={userDetails}
//                 onLogout={logout}
//               />
//             </Sider>
//           )}

//           <Content
//             style={{
//               margin: "16px",
//               padding: 16,
//               overflow: "auto",
//               scrollbarWidth: "none",
//               scrollbarGutter: "stable",
//               borderRadius: "10px",
//             }}
//           >
//             <Outlet />
//           </Content>

//         </Layout>
//       </Layout>
//     </Spin>
//   ) : (
//     <Navigate to="/login" />
//   );
// };

// export default HomePage;

import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import {
  Layout,
  Menu,
  Button,
  message,
  Spin,
  Flex,
  Tooltip,
  Drawer,
} from "antd";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { logOut } from "../Service/logout";
import { useSessionRefresh } from "./useSessionRefresh";
import SessionChallengeListener from "./SessionChallengeListener";
import Sider from "antd/es/layout/Sider";
import { MdLogout, MdMenu } from "react-icons/md";
import { BiSolidUserCircle } from "react-icons/bi";
import { usePermissions } from "../../context/PermissionContext";

// ── Single source of truth for the menu ──────────────────────────────────────
// To remove a module for a client, edit menuConfig.js — it updates both
// the sidebar here and the dashboard cards automatically.
import { buildMenuItems } from "../../utils/menuConfig";

const { Content, Header } = Layout;

const DESKTOP_BREAKPOINT = 1024;

// ─── SidebarContent ───────────────────────────────────────────────────────────
const SidebarContent = ({ showTitle = true, onNavigate, menuItems, userDetails, onToggle, onLogout }) => (
  <>
    <Button
      type="text"
      block
      onClick={onToggle}
      style={{ margin: "15px 0px" }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
        alt="Logo"
        style={{ width: "3rem", height: "auto", borderRadius: "50%" }}
      />
      {showTitle && <h3 style={{ margin: 0 }}>Step to Innovation</h3>}
    </Button>

    <Menu
      mode="inline"
      onClick={({ key }) => { if (onNavigate) onNavigate(key); }}
      style={{
        overflowY: "auto",
        height: "calc(100vh - 170px)",
        scrollbarWidth: "none",
      }}
      items={menuItems}
    />

    <div
      style={{
        position: "absolute",
        bottom: 0,
        width: "100%",
        background: "white",
        padding: "10px",
        borderTop: "1px solid #f0f0f0",
        textAlign: "center",
      }}
    >
      <Flex
        align="center"
        justify={showTitle ? "flex-start" : "center"}
        style={{ marginBottom: "8px" }}
      >
        {showTitle ? (
          <>
            <BiSolidUserCircle style={{ fontSize: "40px", marginRight: "10px", color: "gray" }} />
            <div style={{ textAlign: "start" }}>
              <div>{userDetails?.name || "User Name"}</div>
              <small style={{ color: "gray" }}>
                {userDetails?.roles || userDetails?.role || "User Role"}
              </small>
            </div>
          </>
        ) : (
          <Tooltip
            title={
              <div style={{ textAlign: "start" }}>
                <div>{userDetails?.name || "User Name"}</div>
                <small>{userDetails?.roles || userDetails?.role || "User Role"}</small>
              </div>
            }
            placement="right"
          >
            <BiSolidUserCircle style={{ fontSize: "40px", color: "gray" }} />
          </Tooltip>
        )}
      </Flex>
      <Button
        type="text"
        block
        onClick={onLogout}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: showTitle ? "8px" : "0px",
        }}
      >
        <MdLogout /> {showTitle && "Logout"}
      </Button>
    </div>
  </>
);

// ─── HomePage ─────────────────────────────────────────────────────────────────
const HomePage = () => {
  const [open, setOpen] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= DESKTOP_BREAKPOINT);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const { can, loading: permLoading } = usePermissions();

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= DESKTOP_BREAKPOINT);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const toggleDrawer = () => setOpen((v) => !v);

  const logout = () => {
    setIsLoading(true);
    logOut()
      .catch((err) => {
        messageApi.open({
          type: "error",
          content: err.message || err.response?.data?.message,
        });
      })
      .finally(() => {
        Cookies.remove("user_details");
        Cookies.remove("AUTH_TOKEN");
        Cookies.remove("REFRESH_TOKEN");
        navigate("/login", { replace: true });
        setIsLoading(false);
      });
  };

  useEffect(() => {
    const details = Cookies.get("user_details");
    if (details) {
      try {
        setUserDetails(JSON.parse(details));
      } catch {
        setUserDetails(null);
      }
    }
  }, []);

  useSessionRefresh();

  // buildMenuItems is now imported from menuConfig.js
  // Pass can + userDetails as params — no more closure dependency
  const menuItems = buildMenuItems({ can, userDetails });

  const isLoggedIn = Cookies.get("user_details");
  return isLoggedIn ? (
    <Spin spinning={isLoading || permLoading}>
      {contextHolder}
      <SessionChallengeListener />
      <Layout style={{ height: "100vh" }}>
        <Layout>

          {/* ── TABLET & MOBILE ── */}
          {isMobile && (
            <>
              <Header
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 100,
                  width: "100%",
                  background: "white",
                  padding: "0 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  borderBottom: "1px solid #f0f0f0",
                  height: "56px",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                }}
              >
                <Button
                  type="text"
                  icon={<MdMenu style={{ fontSize: "22px" }} />}
                  onClick={() => setDrawerOpen(true)}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
                  alt="Logo"
                  style={{ width: "2rem", height: "auto", borderRadius: "50%" }}
                />
                <h3 style={{ margin: 0, fontSize: "16px" }}>Step to Innovation</h3>
              </Header>

              <Drawer
                placement="left"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                width={260}
                styles={{ body: { padding: 0, position: "relative" } }}
                title={null}
                closable={false}
              >
                <SidebarContent
                  onNavigate={(key) => { navigate(key); setDrawerOpen(false); }}
                  menuItems={menuItems}
                  userDetails={userDetails}
                  onLogout={logout}
                />
              </Drawer>
            </>
          )}

          {/* ── DESKTOP ── */}
          {!isMobile && (
            <Sider
              style={{
                background: "white",
                overflow: "hidden",
                height: "100vh",
                position: "sticky",
                insetInlineStart: 0,
                top: 0,
                bottom: 0,
                scrollbarWidth: "none",
                scrollbarGutter: "stable",
              }}
              collapsible
              collapsed={!open}
              onCollapse={toggleDrawer}
              width={250}
              trigger={null}
            >
              <SidebarContent
                showTitle={open}
                onNavigate={(key) => navigate(key)}
                onToggle={toggleDrawer}
                menuItems={menuItems}
                userDetails={userDetails}
                onLogout={logout}
              />
            </Sider>
          )}

          <Content
            style={{
              margin: "16px",
              padding: 16,
              overflow: "auto",
              scrollbarWidth: "none",
              scrollbarGutter: "stable",
              borderRadius: "10px",
            }}
          >
            <Outlet />
          </Content>

        </Layout>
      </Layout>
    </Spin>
  ) : (
    <Navigate to="/login" />
  );
};

export default HomePage;